export const text = {
  PAYMENT_METHOD: 'Payment method',
  NEW: 'New',
}
export const styles = {
  BUTTON_CONTAINER_STYLE: {
    height: 40,
    width: 88,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 5,
  },
  BUTTON_IMAGE_STYLE: { height: 16.5, width: 16.5 },
}
